/*
 * 账户信息
 */
import Vue from 'vue'

const vm = new Vue()
// 账单记录
export function getInfo (params) {
  return vm.$http.post('r/api?sysName=CCB&apiName=CM-MOB-IF06', params)
}

// 获取登录人的信息，根据账号密码获得北燃的token
export function getBjtongAccessToken (params) {
  return vm.$http.post('c/api/bjtong/getBjtongAccessToken', params)
}

// 校验户号并绑定
export function checkUserGas (params) {
  return vm.$http.post('i/api/bjtong/checkUserGas', params)
}

// 记录用户操作类型
export function operationRecords (params) {
  return vm.$http.post('i/api/bjtong/operationRecords', params)
}
